import axios from 'axios';

const list = () => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/Dashboard/stats`,
    withCredentials: true,
});

export default {
    list,
};
